<div class="form-panel-container">
    <div class="roles-container">
        <table [ngClass]="{ 'role-rights-table': true, 'role-rights-table-read-only': enumHelper.areEquals(FormMode, _context.mode, FormMode.Reading) }" class="mat-elevation-z8">
            <tr class="mat-mdc-row">
                <th class="mat-mdc-header-cell"><span class="header-text">Droits BackOffice</span></th>
                <th class="mat-mdc-header-cell"><span class="header-text">Lecture</span></th>
                <th class="mat-mdc-header-cell"><span class="header-text">Création</span></th>
                <th class="mat-mdc-header-cell"><span class="header-text">Édition</span></th>
                <th class="mat-mdc-header-cell"><span class="header-text">Suppression</span></th>
            </tr>
            <tr
                class="mat-mdc-row"
                app-role-rights-tr
                rigthName="Organisations"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [readRights]="Rights.OrganizationRead"
                [createRights]="Rights.OrganizationCreate"
                [editRights]="Rights.OrganizationEdit"
                [deleteRights]="Rights.OrganizationDelete"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
            <tr
                class="mat-mdc-row"
                app-role-rights-tr
                rigthName="Groupes/Utilisateurs"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [readRights]="Rights.GroupAndUserRead"
                [createRights]="Rights.GroupAndUserCreate"
                [editRights]="Rights.GroupAndUserEdit"
                [deleteRights]="Rights.GroupAndUserDelete"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
            <tr
                class="mat-mdc-row"
                app-role-rights-tr
                rigthName="Rôles"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [readRights]="Rights.RoleRead"
                [createRights]="Rights.RoleCreate"
                [editRights]="Rights.RoleEdit"
                [deleteRights]="Rights.RoleDelete"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
            <tr
                class="mat-mdc-row"
                app-role-rights-tr
                rigthName="Bannettes"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [readRights]="Rights.BoxRead"
                [createRights]="Rights.BoxCreate"
                [editRights]="Rights.BoxEdit"
                [deleteRights]="Rights.BoxDelete"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
            <tr
                class="mat-mdc-row"
                app-role-rights-tr
                rigthName="Workflows"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [readRights]="Rights.WorkflowDefinitionRead"
                [createRights]="Rights.WorkflowDefinitionCreate"
                [editRights]="Rights.WorkflowDefinitionEdit"
                [deleteRights]="Rights.WorkflowDefinitionDelete"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
            <tr
                class="mat-mdc-row"
                app-role-rights-tr
                rigthName="États de dossier"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [readRights]="Rights.FolderStateRead"
                [createRights]="Rights.FolderStateCreate"
                [editRights]="Rights.FolderStateEdit"
                [deleteRights]="Rights.FolderStateDelete"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
            <tr
                class="mat-mdc-row"
                app-role-rights-tr
                rigthName="Jeux d'états de Workflow"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [readRights]="Rights.StatesSetRead"
                [createRights]="Rights.StatesSetCreate"
                [editRights]="Rights.StatesSetEdit"
                [deleteRights]="Rights.StatesSetDelete"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
            <tr
                class="mat-mdc-row"
                app-role-rights-tr
                rigthName="Attributs"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [readRights]="Rights.AttributRead"
                [createRights]="Rights.AttributCreate"
                [editRights]="Rights.AttributEdit"
                [deleteRights]="Rights.AttributDelete"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
            <tr
                class="mat-mdc-row"
                app-role-rights-tr
                rigthName="Mises en page de vue"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [readRights]="Rights.ListLayoutRead"
                [createRights]="Rights.ListLayoutCreate"
                [editRights]="Rights.ListLayoutEdit"
                [deleteRights]="Rights.ListLayoutDelete"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
            <tr
                class="mat-mdc-row"
                app-role-rights-tr
                rigthName="Modèles de mails"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [readRights]="Rights.EmailTemplateRead"
                [createRights]="Rights.EmailTemplateCreate"
                [editRights]="Rights.EmailTemplateEdit"
                [deleteRights]="Rights.EmailTemplateDelete"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>

            <tr
                class="mat-mdc-row"
                app-role-rights-tr
                rigthName="Modèles de SMS"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [readRights]="Rights.SmsTemplateRead"
                [createRights]="Rights.SmsTemplateCreate"
                [editRights]="Rights.SmsTemplateEdit"
                [deleteRights]="Rights.SmsTemplateDelete"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
            <tr
                class="mat-mdc-row"
                app-role-rights-tr
                rigthName="Clients"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [readRights]="Rights.CustomerRead"
                [createRights]="Rights.CustomerCreate"
                [editRights]="Rights.CustomerEdit"
                [deleteRights]="Rights.CustomerDelete"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
            <tr
                class="mat-mdc-row"
                app-role-rights-tr
                rigthName="Articles"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [readRights]="Rights.ArticleRead"
                [createRights]="Rights.ArticleCreate"
                [editRights]="Rights.ArticleEdit"
                [deleteRights]="Rights.ArticleDelete"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
            <tr
                class="mat-mdc-row"
                app-role-rights-tr
                rigthName="Types de documents"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [readRights]="Rights.DocumentTypeRead"
                [createRights]="Rights.DocumentTypeCreate"
                [editRights]="Rights.DocumentTypeEdit"
                [deleteRights]="Rights.DocumentTypeDelete"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
            <tr
                class="mat-mdc-row"
                app-role-rights-tr
                rigthName="Processus"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [readRights]="Rights.ProcessRead"
                [createRights]="Rights.ProcessCreate"
                [editRights]="Rights.ProcessEdit"
                [deleteRights]="Rights.ProcessDelete"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
            <tr
                class="mat-mdc-row"
                app-role-rights-tr
                rigthName="Paramètres"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [readRights]="Rights.ParameterRead"
                [createRights]="Rights.ParameterCreate"
                [editRights]="Rights.ParameterEdit"
                [deleteRights]="Rights.ParameterDelete"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
            <tr
                class="mat-mdc-row"
                app-role-rights-tr
                rigthName="Vues"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [readRights]="Rights.ViewRead"
                [createRights]="Rights.ViewCreate"
                [editRights]="Rights.ViewEdit"
                [deleteRights]="Rights.ViewDelete"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
            <tr
                class="mat-mdc-row"
                app-role-rights-tr
                rigthName="Adresses mail"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [readRights]="Rights.EmailAddressRead"
                [createRights]="Rights.EmailAddressCreate"
                [editRights]="Rights.EmailAddressEdit"
                [deleteRights]="Rights.EmailAddressDelete"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
            <tr
                class="mat-mdc-row"
                app-role-rights-tr
                rigthName="Contacts"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [readRights]="Rights.ContactRead"
                [createRights]="Rights.ContactCreate"
                [editRights]="Rights.ContactEdit"
                [deleteRights]="Rights.ContactDelete"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>

            <tr
                class="mat-mdc-row"
                app-role-rights-tr
                rigthName="Abonnement"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [readRights]="Rights.SubscriptionRead"
                [editRights]="Rights.SubscriptionEdit"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>

            <tr
                class="mat-mdc-row"
                app-role-rights-tr
                rigthName="Configuration d'API"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [readRights]="Rights.ApiConfigurationRead"
                [createRights]="Rights.ApiConfigurationCreate"
                [editRights]="Rights.ApiConfigurationEdit"
                [deleteRights]="Rights.ApiConfigurationDelete"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
        </table>

        <table [ngClass]="{ 'role-rights-table': true, 'role-rights-table-read-only': enumHelper.areEquals(FormMode, _context.mode, FormMode.Reading) }" class="mat-elevation-z8">
            <tr class="mat-mdc-row">
                <th class="mat-mdc-header-cell"><span class="header-text">Droits BackOffice</span></th>
                <th class="mat-mdc-header-cell"><span class="header-text">Activé</span></th>
            </tr>
            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="Attribution de rôles"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.ModifyUserRoles"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="Administration des organisations enfants"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.ChildOrganizationAdministration"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="Activation de l'archivage"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.Archiving"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="Personnalisation du suivi de dossier"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.CustomizeFolderTracking"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
        </table>

        <table [ngClass]="{ 'role-rights-table': true, 'role-rights-table-read-only': enumHelper.areEquals(FormMode, _context.mode, FormMode.Reading) }" class="mat-elevation-z8">
            <tr class="mat-mdc-row">
                <th class="mat-mdc-header-cell"><span class="header-text">Droits FrontOffice</span></th>
                <th class="mat-mdc-header-cell mat-mdc-header-cell-action"><span class="header-text">Activé</span></th>
            </tr>
            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="Vue bannettes"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.BoxView"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="Vue workflows"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.WorkflowView"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="Consultation de dossier"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.FolderRead"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="Création de dossier"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.FolderCreate"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="Édition de dossier"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.FolderEdit"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="Suppression de dossier"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.FolderDelete"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>

            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="Modification de l'état lu / non lu"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.toggleReadState"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>

            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="Archivage d'un dossier"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.ArchiveCreate"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>

            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="Consultation des archives"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.ArchiveRead"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>

            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="Déplacement d'un dossier dans une bannette"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.MoveFolderToBox"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>

            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="Fusion de dossiers"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.MergeFolder"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>

            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="Duplication de dossiers"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.DuplicateFolder"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>

            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="Ajout de document"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.AddFileToFolder"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>

            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="Ajout de commentaire"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.AddComment"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>

            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="Modification de commentaire"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.UpdateComment"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>

            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="Suppression de commentaire"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.DeleteComment"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>

            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="Affichage de l'historique des commentaires"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.ViewCommentHistory"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>

            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="Envoi de mail"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.SendEmail"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>

            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="Envoi de SMS"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.SendSms"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>

            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="Mise en veille de dossier"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.ChangeStandByState"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
        </table>

        <table [ngClass]="{ 'role-rights-table': true, 'role-rights-table-read-only': enumHelper.areEquals(FormMode, _context.mode, FormMode.Reading) }" class="mat-elevation-z8">
            <tr class="mat-mdc-row">
                <th class="mat-mdc-header-cell"><span class="header-text">Droits FrontOffice</span></th>
                <th class="mat-mdc-header-cell mat-mdc-header-cell-action"><span class="header-text">Activé</span></th>
            </tr>
            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="Consultation des rappels"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.ReminderRead"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="Création de rappel"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.ReminderCreate"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="Édition de rappel"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.ReminderEdit"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="Suppression de rappel"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.ReminderDelete"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>

            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="Consultation des notification des rappels"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.ReminderNotificationRead"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="Suppression des notifications des rappels"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.ReminderNotificationEdit"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="Activation d'une étape de workflow."
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.WorkflowStepActivation"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="clôture d'une étape de workflow"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.WorkflowStepCompletion"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="Supervision"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.Supervision"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="Déverrouiller un dossier"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.UnlockFolder"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="Exporter des dossiers"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.ExportFolders"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="Suppression de document"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.DocumentDelete"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="Gestion des filtres"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.ManagePredefinedFilters"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="Modification des paramètres du profil"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.ProfileEdit"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>

            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="Suivi de dossiers"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.FollowFolder"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>

            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="Consulter des brouillons de mail"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.DraftEmailRead"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>

            <tr
                class="mat-mdc-row"
                app-simple-role-right-tr
                rigthName="Gérer des brouillons de mail"
                [disabled]="disabled"
                [context]="_context"
                [roleRights]="_context.item.rights"
                [rightId]="Rights.DraftEmailWrite"
                (checkboxChangedValue)="checkboxChanged($event)"></tr>
        </table>
    </div>
    <div class="buttons-container">
        @if (enumHelper.areNotEquals(FormMode, _context.mode, FormMode.Reading)) {
            <button mat-stroked-button class="accent-button" (click)="cancel()">Annuler</button>
        }
        <button mat-raised-button class="accent-button" (click)="$event.stopPropagation(); onExported()">Exporter</button>
        <!-- <button *ngIf="enumHelper.areNotEquals(FormMode, _context.mode, FormMode.Reading)" mat-raised-button class="accent-button"(click)="$event.stopPropagation();fileToUpload.click()">Importer</button> -->
        @if (enumHelper.areNotEquals(FormMode, _context.mode, FormMode.Reading)) {
            <button mat-raised-button class="accent-button" (click)="manualSave()">Enregistrer</button>
        }
        <!-- <input ng2FileSelect #fileToUpload class="file-to-upload" type="file" [uploader]="uploader" (change)="onFileSelected()" [hidden]="true" /> -->
    </div>
</div>
